// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"TextArea__pc_only___1fIAO","sp_only":"TextArea__sp_only___1eapv","textarea":"TextArea__textarea___2mMr3"};